module.exports = __webpack_public_path__ + "static/media/console.338af270.svg";